import {translations} from 'presentation/translations-new';
import {z} from 'zod';

const {email} = translations['pt-br'].privateFlow.profile.changeData.contactErrors;
export const EmailSchema = z.object({
	email: z.string().email(email),
});

export type EmailSchemaFormValues = z.infer<typeof EmailSchema>;
